"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleMasterPage = void 0;
const master_page_1 = require("./master-page");
const React = require("react");
const names_1 = require("./names");
class SimpleMasterPage extends master_page_1.MasterPage {
    constructor() {
        super(...arguments);
        this.name = names_1.masterPageNames.simple;
    }
    get element() {
        return this.pageContainer;
    }
    render() {
        return React.createElement("div", { ref: e => this.pageContainer = e || this.pageContainer });
    }
}
exports.SimpleMasterPage = SimpleMasterPage;
